export default __webpack_public_path__ + "static/media/order-summary-error.030e1434.svg";